export const fieldsMapApresentacao = {
    ocorrenciaNo: { name: 'apresentacaoId', type: 'number' },
    V_28009: { name: 'apresentacaoId', type: 'number' },
    V_28010: { name: 'name', type: 'string' },
    V_28011: { name: 'habilitado', type: 'boolean' },
};
